import { render } from "./RecordTypes.vue?vue&type=template&id=2b57fb6a&scoped=true"
import script from "./RecordTypes.vue?vue&type=script&lang=js"
export * from "./RecordTypes.vue?vue&type=script&lang=js"

import "./RecordTypes.vue?vue&type=style&index=0&id=2b57fb6a&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b57fb6a"]])

export default __exports__